(function () {
    'use strict';

    // A very simple filter that allows using translations without needing to load the 
    // translations onto the (root)scope.
    // Usage: {{ 'TranslationKey' | habilTranslation }}
    angular.module('app').filter('habilTranslation', FilterFactory);

    FilterFactory.$inject = ['translationsService'];
    function FilterFactory(translationsService) {
         function habilTranslation(key) {
            return translationsService.GetTranslationByKey(key);
        }
        habilTranslation.$stateful = true;
        return habilTranslation;
    }    
})();